import { useListEntityApi } from "@/common/api/listEntityApi";
import type { InboundDeliveryResponse } from "./common/inboundDeliveryResponse";

interface InboundDeliveryPageResponse {
  deliveries: InboundDeliveryResponse[];
}

export interface ListInboundDeliveryResponse {
  ok: true;
  deliveries: InboundDeliveryResponse[];
}

export function useListInboundDeliveryApi() {
  return useListEntityApi<ListInboundDeliveryResponse>({
    url: 'delivery/inbound',
    translate: (t) => t.inboundDelivery.actions.fetchMany,
    async processOk(response) {
      const data = await response.json() as InboundDeliveryPageResponse;
      return {
        ok: true,
        deliveries: data.deliveries
      };
    },
  });
}
